//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'AmapNB',
  data () {
    return {
      isMarkerShow: true
    }
  },
  created () {
    console.log('26')
  },
  mounted () {
    console.log('29')
    setTimeout(() => {
      this.isAddMarker()
    }, 700)
  },
  methods: {
    isAddMarker () {
      // var mapDevice = "869975030552874"+"≯"+
      //   "113.884824"+"≯"+
      //   "22.594301"+"≯"+
      //   "方形测试"+"≯"+
      //   "艾米kw"+"≯"+
      //   "-327.7"+"≯"+
      //   "3.13"+"≯"+
      //   "M5311-UDP"+"≯"+
      //   "2019-06-20 11:01:34"+"≯"+
      //   "2020-12-20 16:15:30"+"≯"+
      //   "美兰大厦2412"+"≯"+
      //   "";
      console.log('48', this.$route.query.Imei)
      // window.frames['mainIframe'].window.getAddNewMarkers(mapDevice)
      this.$http.post(this.base + 'queryxfdevice?token=' + this.$store.getters.get_token, {
        imei: this.$route.query.Imei}).then(res => {
        console.log('edit', res)
        if (res.data.code === 200) {
          window.frames['mainIframe'].window.getAddNewMarkers(res.data.data)
        } else {
          this.errText = res.data.msg
          this.editErr = true
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/device/AmapNB.vue